
import { useState, useEffect } from "react";
import { MortgageData } from "../CalculatorTabs";
import { STATES } from "@/components/buyingPower/steps/location/constants";
import { CITIES_BY_STATE } from "@/constants/locationData";

export const useLocationData = (mortgageData: MortgageData) => {
  const [states, setStates] = useState<{id: string, name: string, abbreviation: string}[]>([]);
  const [cities, setCities] = useState<{id: string, name: string}[]>([]);

  // Transform the STATES array to the format needed for the component
  useEffect(() => {
    const formattedStates = STATES.map((state, index) => ({
      id: (index + 1).toString(),
      name: state.label,
      abbreviation: state.value
    }));
    
    setStates(formattedStates);
  }, []);
  
  // Update cities based on selected state
  useEffect(() => {
    if (!mortgageData.location.state) {
      setCities([]);
      return;
    }
    
    // Get cities based on the selected state
    const selectedState = mortgageData.location.state;
    setCities(CITIES_BY_STATE[selectedState] || []);
  }, [mortgageData.location.state]);

  return { states, cities };
};
